import Vue from "vue";
import i18n from "./i18n";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/reset.scss";
import "./assets/css/rtlang.scss";
import "./assets/css/common.scss";
import "./assets/icons"; //svg图标
import "./assets/css/vtip.css";
import remFnc from "./assets/js/rem";
import "./assets/fonts/font.css";
import "animate.css";
import directive from "./directive";
import VueClipboard from "vue-clipboard2";
Vue.use(directive);
Vue.use(VueClipboard);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

try {
  await import("./assets/css/vtip.css");

  const Vtip = (await import("vtip")).default;

  Vue.use(Vtip.directive);

  Vue.prototype.$tip = Vtip.tip;
} catch (err) {
  console.log("vtip init error:", err);
}
